// extracted by mini-css-extract-plugin
module.exports = {"standardHeader":"_3lJxYGf","dividerHeader":"_2m6vPaK"};
    if(module.hot) {
      // 1545369437744
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  